import React from 'react';

const ProgressStepperContext = React.createContext();

export function useProgressStepper() {
  return React.useContext(ProgressStepperContext);
}

export default ProgressStepperContext;